import { type PropsWithChildren } from 'react'
import createCache, { type EmotionCache } from '@emotion/cache'
import { CacheProvider as EmotionCacheProvider } from '@emotion/react'

let muiCache: EmotionCache | undefined

// reason: this is how we set it up :)
// eslint-disable-next-line no-return-assign
const createMuiCache = (nonce?: string) =>
  (muiCache =
    muiCache ??
    createCache({
      key: 'mui',
      nonce,
      prepend: true,
    }))

type Props = {
  nonce?: string
}

export const CacheProvider = ({ children, nonce }: PropsWithChildren<Props>) => (
  <EmotionCacheProvider value={createMuiCache(nonce)}>{children}</EmotionCacheProvider>
)
